import { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Star, ExternalLink } from "lucide-react";

const REVIEW_URL = "https://www.google.com/search?sca_esv=0445900a5023e21a&hl=it-IT&sxsrf=APpeQnvzEAfTH3pQi1wyYOJzXwgoZjwCGQ:1789148138317&q=recensioni+di+la+caffetteria+del+fortino&uds=AJ5uw1_a2D0D09lxm8gpKKOTUn4r9o8EtIr7w4auRdy15uM4Z0PV8T2RtjhYKxIyZyprgqDAAbt-Zzly8vmdP8EfnCokGA1q9jWjJ-oQOrz_6AQgrhvZyugYrRLxJBCJ_Ptha30ueuXPkeZ1arM2IWIMX7tMj11g_8CCr-tJvQWpTaRGt1Ub0tPUjAQLsEOJrajEs-jMIpKf&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_4am0XKo8ok5v8Cbl1_8lcp9VEfkmnvM6YKqDQuTQlkw97NOysehrLb4I2UkEU-KsQ4vAGQc422avBKBmQg2Zcg2UJc4iKcGSC7kYHMbB4GltqM-FFkDNS59AGvQKcZFa0wKTpc%3D&sa=X&ved=2ahUKEwjN8O-ZiOeWAxXn9LsIHbEvG4gQxKsJKAJ6BAgTEAE&ictx=1&stq=1&cs=0&lei=6jukas3TEufp7_UPsd_swAg";

export function ReviewQR() {
  const { t } = useLanguage();
  const [imgOk, setImgOk] = useState(true);

  if (!imgOk) return null;

  return (
    <div
      data-testid="review-qr-section"
      className="bg-white border border-[#E8DFD5] rounded-2xl p-6 shadow-[0_8px_30px_rgb(0,0,0,0.06)] flex flex-col sm:flex-row items-center gap-5"
    >
      <a
        data-testid="review-qr-link"
        href={REVIEW_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="shrink-0 transition-transform hover:scale-105"
        title={t("review_title")}
      >
        <img
          src="/qr-recensione.jpeg"
          alt={t("review_title")}
          onError={() => setImgOk(false)}
          className="w-36 h-36 rounded-xl border border-[#E8DFD5] object-contain bg-white p-1"
        />
      </a>
      <div className="text-center sm:text-left">
        <div className="flex items-center justify-center sm:justify-start gap-1.5 text-[#D97706]">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="w-4 h-4 fill-current" />
          ))}
        </div>
        <h3 className="font-heading text-xl font-semibold text-[#4A2C2A] mt-2">{t("review_title")}</h3>
        <p className="text-sm text-[#786C66] mt-1 max-w-xs">{t("review_subtitle")}</p>
        <a
          data-testid="review-text-link"
          href={REVIEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-sm font-semibold text-[#D97706] hover:text-[#b45309] mt-2"
        >
          {t("review_open_link")} <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </div>
    </div>
  );
}
